/* Pupdates motion layer: scroll reveals + load animation. Respects reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('pup-js');

  var selectors = [
    '.pup-hero__eyebrow', '.pup-hero__heading', '.pup-hero__text', '.pup-hero__actions', '.pup-hero__media',
    '.pup-h2', '.pup-lede',
    '.pup-icons__item', '.pup-icons__heading',
    '.pup-classes__locs > li', '.pup-classes__head',
    '.pup-locations__grid > li',
    '.pup-steps__item',
    '.pup-imgtext__media', '.pup-imgtext__copy > *',
    '.pup-bento__gallery', '.pup-bento__copy > *',
    '.pup-testi__stage',
    '.pup-more__card',
    '.pup-dg__details', '.pup-dg__gift',
    '.pup-faq__side', '.pup-faq__head',
    '.pup-enquiry__media', '.pup-enquiry__panel > *',
    '.pup-contact__details', '.pup-contact__formwrap',
    '.pup-cart__title', '.pup-cart__item', '.pup-cart__summary',
    '.pup-product__gallery'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function scan() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll(selectors).forEach(function (el) {
      if (el.dataset.pupMotion) return;
      el.dataset.pupMotion = '1';

      var parent = el.parentElement;
      var index = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.setProperty('--pup-d', Math.min(index, 6) * 80 + 'ms');

      var rect = el.getBoundingClientRect();
      var visible = rect.width > 0 && rect.height > 0;
      if (visible && rect.top < vh * 0.92 && rect.bottom > 0) {
        el.classList.add('pup-load');
      } else {
        el.classList.add('pup-reveal');
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scan();
  });
  document.addEventListener('shopify:section:load', scan);
})();
